import { gql } from '@apollo/client';
const GET_ORDER_DELIVERY_STATUS_AUDITS = gql `
  query GetOrderDeliveryStatusAudits($id: ID!, $first: Int, $after: String) {
    node(id: $id) {
      ... on OrderNode {
        id
        deliveryStatusAudits(first: $first, after: $after) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              changedAt
              changedByUser {
                id
                email
              }
              entries {
                id
                previousStatus
                newStatus
                quantity
                deliveryDate
                orderComponentVariant {
                  id
                  name
                  color
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_ORDER_DELIVERY_STATUS_AUDITS;
